import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setIndustries: (state, action) => {
            state.industries = action.payload;
        },
        setRegions: (state, action) => {
            state.regions = action.payload;
        },
        setLensLayers: (state, action) => {
            state.lensLayers = action.payload;
        },
        setLandplotsLayers: (state, action) => {
            state.landplotsLayers = action.payload;
        },
        setReportLayers: (state, action) => {
            state.reportLayers = action.payload;
        },
        setSites: (state, action) => {
            state.sites = action.payload;
        },
    },
});
export const { setUser, setToken, setIndustries, setRegions, setLensLayers, setLandplotsLayers, setReportLayers, setSites, } = appSlice.actions;
export * from "./selectors";
export default appSlice.reducer;
